var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "apply" }, [
      _c("div", { staticClass: "header" }, [
        _vm._v("\n        Hello,Rong\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info" }, [
        _c("div", { staticClass: "name" }, [_vm._v("Net terms")]),
        _vm._v(" "),
        _c("div", { staticClass: "money" }, [
          _vm._v("\n            $1,200.00\n            "),
          _vm._v(" "),
          _c("div", { staticClass: "status color-green" }, [_vm._v("Active")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "desc" }, [_vm._v("Credits available")]),
        _vm._v(" "),
        _c("div", { staticClass: "type" }, [
          _vm._v("\n            Apply for Terms\n        ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list" }, [
        _c("div", { staticClass: "item" }, [_vm._v("My Coupons")]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [_vm._v("Orders")]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [_vm._v("Online Shop")]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [_vm._v("Account")]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [_vm._v("My Invoices")]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [_vm._v("Setting")]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [_vm._v("Help Center")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sign-out" }, [
        _vm._v("\n        Sign Out\n    ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-416377fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-416377fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/credit-payment/applyDialog.vue
// module id = null
// module chunks = 